import { User } from './user';

export type Steps = {
    _id?: string;
    index?: number;
    name: string;
    description: string;
    maxHourInStep: number;
    defaultExtUsers: User[];
    extUsers?: User[];
    useMillingDeadline?: false;
    millingDeadlineDays?: number | null;
    /** DD-3488: moving one order into this step opens the subcontract flow. */
    initiatesSubcontract?: boolean;
};

export type WorkFlow = {
    _id?: string;
    steps: Steps[];
    defaultNoSample?: string;
    defaultPhysicalSample?: string;
    defaultDigitalSample?: string;
};

export type DefaultSampleStep = {
    defaultNoSample?: string;
    defaultPhysicalSample?: string;
    defaultDigitalSample?: string;
};

export type OverView = {
    _id?: string;
    stepId: string;
    name?: string;
    noOfReadyForInvoice?: string;
    pausedOrders?: number;
    noOfOrders: number;
    noOfConstructions: number;
    noOfActions: number;
};

export type ProductionOverView = {
    noStep: OverView;
    stepOrders: OverView[];
};

export type IncomingOverview = {
    inbox: OverView;
};

export type AdministrationOverview = {
    productionOngoing: OverView;
    productionFinished: OverView;
};

export type Time = {
    hours: number;
    minutes: number;
    seconds: number;
};

export type WorkFlowOverview = {
    incoming: IncomingOverview;
    production: ProductionOverView;
    administration: AdministrationOverview;
};

export type PauseLogEntry = {
    type: 'pause' | 'resume';
    dateTime: Date;
    comment?: string;
    reason?: string;
    createdBy?: { _id: string; fullName: string };
};

export type OrderStep = {
    _id?: string;
    stepId: string;
    name: string;
    departmentName?: string | null;
    iteration: number;
    description: string;
    maxHourInStep: number;
    comment: string;
    dateTime: Date;
    workStarted?: Date;
    isPaused?: boolean;
    pauseReason?: string;
    user: User;
    externalTechnicians: User[];
    timeSpent: Time;
    timeProduction?: Time;
    timeWaiting?: Time;
    totalPauseTime?: Time;
    pauseLog?: PauseLogEntry[];
    millingDeadline?: Date | null;
    useMillingDeadline?: boolean;
    userId?: string;
    extUsers?: string[];
    /** DD-3489: set on a move a sub-order's status made; only the sending lab resolves it. */
    automation?: OrderStepAutomation | null;
};

export type OrderStepAutomation = {
    type: string;
    status: string;
    subOrder?: { _id: string; orderId: string } | null;
};

/** DD-3489: the standard sub-order statuses a rule may react to (OrderStatus enum values). */
export const SUBCONTRACT_RULE_STATUSES = ['SENT_BY_CUSTOMER', 'ACCEPTED_BY_LAB', 'SENT_BY_LAB', 'ORDER_APPROVED'];

export type SubcontractStatusRule = {
    status: string;
    stepId: string;
};

export type SubcontractStatusRuleSet = {
    supplierId: string;
    rules: SubcontractStatusRule[];
};
